$(document).ready(function() {

  var intro = $('.wide');
  console.log(intro);
  $('.vol').click(function() {
      if ($(this).hasClass('fa-volume-xmark')) {
          $(this).addClass('fa-volume-low');
          $(this).removeClass('fa-volume-xmark');
          intro[0].muted = false;
      } else {
          $(this).removeClass('fa-volume-low');
          $(this).addClass('fa-volume-xmark');
          intro[0].muted = true;
      }
  });

  if(window.location.href == "https://hustle-period.myshopify.com/") {
    $('body').addClass('home');
    $('.home #MainContent .shopify-section:nth-of-type(6)').addClass('see-less');
    $('.home #MainContent .shopify-section:nth-of-type(7)').addClass('see-less');
    $('.home #MainContent .shopify-section:nth-of-type(8)').addClass('see-less');
    // $('.home #MainContent .shopify-section:nth-of-type(5)').append('<div class="see-more"><a href="#see-more"><h2>SEE MORE</h2></a></div>');
    $(window).scroll(function() {
      if($(window).scrollTop() > 3500) {
        $('.shopify-section').removeClass('see-less');
      }
    });
    // $('.see-more').click(function(e) {
    //   e.preventDefault();
    //   $('.shopify-section').removeClass('see-less');
    //   $(this).fadeOut();
    // });
  }
  
});